import { CdkMonitorFocus } from '@angular/cdk/a11y';
import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { MatIconButton } from '@angular/material/button';
import { MatCard, MatCardContent, MatCardTitle } from '@angular/material/card';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatIcon } from '@angular/material/icon';
import { MatToolbar } from '@angular/material/toolbar';
import { TranslatePipe } from '@ngx-translate/core';
import { ChartRssiCylinderComponent } from '../chart-rssi-cylinder/chart-rssi-cylinder.component';
import { ChartRssiReceiverComponent } from '../chart-rssi-receiver/chart-rssi-receiver.component';

@Component({
  selector: 'oyan-ui-chart-dialog',
  templateUrl: './chart-dialog.component.html',
  imports: [
    TranslatePipe,
    MatCard,
    MatCardTitle,
    MatIcon,
    MatIconButton,
    MatToolbar,
    CdkMonitorFocus,
    ChartRssiReceiverComponent,
    MatCardContent,
    ChartRssiCylinderComponent
  ],
  changeDetection: ChangeDetectionStrategy.Eager,
  providers: []
})
export class ChartDialogComponent {
  dialogRef: MatDialogRef<ChartDialogComponent> = inject(MatDialogRef<ChartDialogComponent>);
  data: {
    id: string;
    type: 'cylinder' | 'receiver';
  } = inject(MAT_DIALOG_DATA);

  close() {
    this.dialogRef.close();
  }
}
